
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit15'
})
export default class AgeLimit15 extends Vue {}
